import { useEffect, useRef } from 'react';
import { motion, useAnimation } from 'framer-motion';

//MUI
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

//Our Imports
import { imageExist } from '../../assets/js/init';
import { DrawTitle } from '../../assets/component/initComponent';
import { Link } from 'react-router-dom';


const Footer = ({ footerInView, navTrigger }) => {

	// const [footerInView, setFooterInView] = useState(false);

	const theme    = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md')); 

	const controls = useAnimation();

	//Ref
	const hasAnimatedOnScroll = useRef(false);

	//Trigger Animation for Nav Click
	useEffect(() => {
		let isActive = true;

		const replay = async () => {
			if (!navTrigger) return;
			await controls.start('hidden');

			if (!isActive) return;
			await controls.start('visible');

			if (!isActive) return;
		};

		replay();

		return () => {
			isActive = false;
		};
	}, [navTrigger, controls]);

	useEffect(() => {
		if (footerInView && !hasAnimatedOnScroll.current) {
			controls.start('visible');
			hasAnimatedOnScroll.current = true; // lock it
		}
	}, [footerInView, controls]);

	//Footer Links and Descriptions
	const footer1 = [
		{
			title: 'Create, Calculate, Grow',
			description: 'Easy Calculators With Support—Right In Your Pocket.'
		},
		{
			title: 'Terms Of Services',
			description: 'Learn How Artha Works And What You Agree To.'
		}
	];

	const footer2 = [
		{
			title: 'Support',
			description: 'Have Questions Or Need Help? Start Here.'
		},
		{
			title: 'Privacy Policy',
			description: 'We Respect Your Data — No Tracking, No Storing.',
			link: '/privacy-policy'
		}
	];

	const textVariant = {
		hidden: {
			opacity: 0,
			x: -140
			// scale: 0.5,
			// y: 250
		},
		visible: {
			opacity: 1,
			x: 0,
			// scale: 1,
			// y: 250,
			transition: {
				duration: 2,
				ease: [0.22, 1, 0.36, 1] // <-- smooth premium easing (important)
			}
		}
	};

	// const storeVaraint = {
	// 	hidden: {
	// 		opacity: 0,
	// 		// x: -140,
	// 		// scale: 0.5,
	// 		// y: 250
	// 	},
	// 	visible: {
	// 		opacity: 1,
	// 		// x: 0,
	// 		// scale: 1,
	// 		// y: 0,
	// 		transition: {
	// 			delay: 1,
	// 			duration: 1,
	// 			ease: [0.22, 1, 0.36, 1] // <-- smooth premium easing (important)
	// 		}
	// 	}
	// };

	// // Parent controls the timing (stagger)
	// const containerVariant = {
	// 	hidden: {},
	// 	visible: {
	// 		transition: {
	// 			staggerChildren: 0.3,   // delay between cards
	// 			delayChildren: 0.5
	// 		}
	// 	}
	// };

	// // Each card animation
	// const cardVariant = {
	// 	hidden: {
	// 		opacity: 0,
	// 		// y: 100
	// 		scale: 0.75
	// 	},
	// 	visible: {
	// 		opacity: 1,
	// 		// y: 0,
	// 		scale: 1,
	// 		transition: {
	// 			duration: 0.5,
	// 			ease: [0.22, 1, 0.36, 1] // <-- smooth premium easing (important)
	// 		}
	// 	}
	// };

	// Parent controls stagger timing
	const containerVariant = {
		hidden: {},
		visible: {
			transition: {
				staggerChildren: 0.3,
				delayChildren: 0.5
			}
		}
	};

	// Each card animation with spring
	const cardVariant = {
		hidden: {
			opacity: 0,
			scale: 0.75
		},
		visible: {
			opacity: 1,
			scale: 1,
			transition: {
				type: 'spring',
				stiffness: 180,
				damping: 12,
				mass: 0.8
			}
		}
	};

	const storeImages = [
		{
			img : 'playStore',
			size: '80px'
		},
		{
			img : 'appstore',
			size: '80px'
		}
	];

	return (
		<Box py={5} pb={0} sx={{ bgcolor: '#242424' }}>
			<Container>
				<Grid container px={{ md: 6, xs: 1 }} spacing={1} mb={3}>
					<Grid size={12}>
						<Stack direction={{ xs: 'column', md: 'row' }} justifyContent='space-between' alignItems='center'>
							<motion.div
								variants={!isMobile ? textVariant : {}}
								initial={!isMobile ? 'hidden' : 'visible'}
								animate={controls}
							>
								<Typography className='font60 fontBolder' sx={{ color: '#BEF053' }}>Let`S Start Now</Typography>
							</motion.div>
							<motion.div
								variants={!isMobile ? containerVariant : {}}
								initial={!isMobile ? 'hidden' : 'visible'}
								animate={controls}
							> 
								<Stack direction={{ xs: 'column', md: 'row' }} spacing={1} alignItems='center'>
									{storeImages.map((list, index) => (
										<motion.div key={index} variants={cardVariant}>
											{imageExist({
												required: '/footer',
												url: `/${list.img}.png`,
												alt: 'screenshot',
												height: list.size
											})}
										</motion.div>
									))}
								</Stack>
							</motion.div>
						</Stack>
					</Grid>
					<Grid size={12} sx={{ bgcolor: '#000', color: '#fff', borderRadius: '20px' }}>
						<Stack direction={{ lg: 'row', sm: 'column' }} spacing={3} justifyContent='space-between' alignItems='center' px={{ md: 4, xs: 2 }}>
							<Stack sx={{ width: { xs: '100%', md: 'max-content' } }} spacing={{ lg: 6, sm: 3, xs: 3 }} py={{ lg: 5, sm: 3, xs: 3 }}>
								{footer1.map((list, foo1Index)=> (
									<Grid key={foo1Index} size={{ md: 12, xs: 12 }}>
										<Typography className='font20 mb5 cursorPointer'>{list.title}</Typography>
										<Typography className='font12 cursorPointer'>{list.description}</Typography>
									</Grid>
								))}
							</Stack>

							<Stack sx={{ width: { xs: '100%', md: 'max-content' } }} spacing={{ lg: 6, sm: 3, xs: 3 }} py={{ lg: 5, sm: 3, xs: 3 }}>
								{footer2.map((list, foo2Index)=> (
									<Grid key={foo2Index} size={{ md: 12, xs: 12 }}>
										<Link to={list.link || '#'} style={{ textDecoration: 'none', color: '#fff' }}>
											<Typography className='font20 mb5 cursorPointer'>{list.title}</Typography>
										</Link>
										<Typography className='font12 cursorPointer'>{list.description}</Typography>
									</Grid>
								))}
							</Stack>


							<Stack sx={{ width: { xs: '100%', md: 'max-content' } }} spacing={{ lg: 6, sm: 3, xs: 3 }} py={{ lg: 5, sm: 3, xs: 3 }} pb={{ lg: 0, sm: 0 , xs: 0 }}>
								<Grid size={12}>
									<Typography className='font20 mb5 cursorPointer'>Calculator</Typography>
									<Typography className='font12 cursorPointer'>All Your Finance Tools, Simplified.</Typography>
								</Grid>
								{/* <motion.div
									variants={containerVariant}
									initial='hidden'
									whileInView='visible'
									viewport={{ once: viewOnce, margin: '-160px' }}
								> */}
								<Stack direction='row' spacing={1} alignItems='flex-end' justifyContent={{ xs: 'center' }}>
									{imageExist({
										required: '/footer',
										url: '/iphone.png',
										alt: 'screenshot',
										height: isMobile ? '90px' : '110px'
									})}
									{imageExist({
										required: '/footer',
										url: '/ipad.png',
										alt: 'screenshot',
										height: isMobile ? '50px' : '80px'
									})}
								</Stack>
								{/* </motion.div> */}
							</Stack>
						</Stack>
					</Grid>
				</Grid>
			</Container>
			<Typography color='#fff' className='font14 txtCenter mb50'>Copyright © {new Date().getFullYear()} <a href='https://cafsinfotech.com/' target='_blank' rel="noreferrer" style={{ color: '#fff' }} className='font14'>Cafsinfotech</a>. All Rights Reserved.</Typography>
			<Box sx={{ width: '100vw', display: 'flex', justifyContent: 'center', borderBottom: '', overflow: 'hidden', position: 'realtive' }} className=''>
				<Box sx={{ height: { md: '100px', xs: '60px' }, width: { md: '550px', xs: '300px' } }}>
					<DrawTitle isView={isMobile ? true : navTrigger || footerInView} isMobile={isMobile}/>
				</Box>
			</Box>
		</Box>
	);
};

export default Footer;
